import { grayGainsboro } from 'constants/colors'
import { sonicSilver } from 'constants/colors'
import { white } from 'constants/colors'
import styled from 'styled-components'

export const Icon = styled.span`
  display: inline-block;
  background: url(${(props) => props.url}) center center no-repeat;
  background-size: 100%;

  width: 17.88px;
  height: 13.75px;
`

export const IconSquare = styled(Icon)`
  height: 17.88px;
  min-width: 17.88px;
`

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 12px;

  width: 240px;
  height: 40px;

  background: ${white};

  border: 1px solid ${grayGainsboro};
  border-radius: 6px;

  flex: none;
  order: 3;
  flex-grow: 0;

  @media (max-width: 994px) {
    width: 100%;
  }
`

export const SearchInput = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 196px;
  height: 24px;
  border: none;
  outline: none;

  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;

  color: ${sonicSilver};
  opacity: 0.75;
`
